import React from "react";

const OutboxCardLoader = () => {
  return (
    <div className="outboxCardWrapper outboxCardLoading">
      <div className="row-left-controls">
        <div className="checkboxBtn">
          <span className="linear-background" style={{ width: '18px', height: '18px', borderRadius: '4px' }} />
        </div>
        <div className="starIcon">
          <span className="linear-background" style={{ width: '16px', height: '16px', borderRadius: '50%' }} />
        </div>
        <div className="avatarIcon">
          <span className="linear-background" style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
        </div>
      </div>
      <div className="recipientInfoSection">
        <div className="recipientInfo">
          <div className="flexCenter linear-background" />
          <div className="recipientEmail linear-background" />
        </div>
      </div>
      <div className="emailInfoWrapper">
        <div className="subjectIcon">
          <span className="linear-background" style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
        </div>
        <div className="emailInfoCont">
          <div className="flexCenter linear-background" style={{ width: '80%', height: '14px' }} />
        </div>
      </div>
      <div className="sentimentColumn">
        <span className="linear-background" style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
      </div>
      <div className="sequenceSection">
        <div className="linear-background" style={{ width: '60px', height: '12px', borderRadius: '2px' }} />
      </div>
      <div className="scheduledDate scheduledMerged">
        <div className="flexCenter linear-background" />
      </div>
      <div className="contactOwner">
        <span className="linear-background"></span>
      </div>
    </div>
  );
};

export { OutboxCardLoader };
export default OutboxCardLoader;
